// extracted by mini-css-extract-plugin
export default {"container":"address-list_container__-P0xy","remove-space":"address-list_remove-space__Zrczf","list-header":"address-list_list-header__Bvwpj"};